import { Box, Typography } from "@mui/material";
import DataGridComponent from "../components/datagrid/datagrid.component";
import { useCallback, useEffect, useRef, useState } from "react";
import { fieldColumns, formatFieldsData } from "../data/fieldsTableConf";
import { useDispatch, useSelector } from "react-redux";
import { fetchFieldsStart } from "../store/features/customer/fields/fieldsSlice";
import CustomDialog from "../components/muiDialogs/dialog.component";
import { dialogMessages } from "../components/forms/utils";
import { Delete, Edit } from "@mui/icons-material";
import {
  deleteFieldStart,
  resetDeleteFieldState,
} from "../store/features/customer/field/fieldSlice";
import { useNavigate } from "react-router";

const LandsPage = () => {
  const dispatch = useDispatch();

  const [fieldCount, setFieldCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedField, setSelectedField] = useState("");
  const searchTimeoutRef = useRef();
  const navigate = useNavigate();

  const accessToken = useSelector((state) => state.auth?.user?.access_token);
  const fieldsData = useSelector((state) => state.fields?.data?.data);
  const isFieldsLoading = useSelector((state) => state.fields?.isLoading);
  const { success } = useSelector((state) => state.field);

  const formattedFields = formatFieldsData(fieldsData);

  const handleSearchChange = useCallback((value) => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    searchTimeoutRef.current = setTimeout(() => {
      setSearchQuery(value);
    }, 500);
  }, []);

  const getFieldsActions = ({ setDialogOpen }) => [
    {
      icon: Edit,
      tooltip: "Modifica",
      onClick: (rowId) => navigate(`/admin/lands/updateField/${rowId}`),
    },
    {
      icon: Delete,
      tooltip: "Elimina",
      onClick: (rowId) => {
        setSelectedField(rowId);
        setDialogOpen(true);
      },
    },
  ];

  const fieldsActions = getFieldsActions({ setDialogOpen });

  const handleDialogConfirm = () => {
    if (selectedField) {
      dispatch(deleteFieldStart({ fieldId: selectedField, accessToken }));
    }
    setDialogOpen(false);
    setSelectedField("");
  };

  useEffect(() => {
    if (!accessToken) {
      return;
    }

    dispatch(fetchFieldsStart({ accessToken, search: searchQuery }));
  }, [accessToken, dispatch, searchQuery]);

  useEffect(() => {
    if (success && accessToken) {
      dispatch(fetchFieldsStart({ accessToken, search: searchQuery }));
      dispatch(resetDeleteFieldState());
    }
  }, [accessToken, dispatch, searchQuery, success]);

  return (
    <Box width={"100%"}>
      <Box sx={{ mb: 3 }}>
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "16px",
            color: "#666666",
          }}
        >
          {isFieldsLoading ? "Caricamento terreni..." : `${fieldCount} terreni`}
        </Typography>
      </Box>
      <DataGridComponent
        onRowCountChange={setFieldCount}
        rows={formattedFields}
        columns={fieldColumns(fieldsActions)}
        inputPlaceholder="Cerca nome terreno o azienda"
        onSearchChange={handleSearchChange}
        loading={isFieldsLoading}
      />
      <CustomDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onConfirm={handleDialogConfirm}
        title={dialogMessages.deleteCustomerField.title}
        description={dialogMessages.deleteCustomerField.description}
      />
    </Box>
  );
};

export default LandsPage;
